// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_ovXNk","nav":"index_nav_L3G9S clearfix","list":"index_list_9BbOB"};